export default "__VITE_ASSET__DqiE06ni__"